// Better Auth client for the SaaS web app.
//
// This talks to the same server as `apps/server/src/auth.ts`; keeping the
// plugin list in sync between client and server is mandatory — the client
// infers its typed endpoints from the plugin set.
//
// Session transport is cookies. In production, cookies are cross-subdomain
// (.oracord.com) so app.oracord.com and api.oracord.com share the session;
// in dev we rely on SameSite=Lax on http://localhost:3500 → :5174, which
// works as long as every fetch sends credentials.

// React subpath: `useSession` etc. are returned as real React hooks
// (useStore-wrapped nanostores). The vanilla `better-auth/client` export
// gives raw atoms, which typecheck as non-callable from components.
import { createAuthClient } from 'better-auth/react';
import { organizationClient } from 'better-auth/client/plugins';
import { API_BASE_URL } from './config';

export const authClient = createAuthClient({
  baseURL: API_BASE_URL,
  plugins: [organizationClient()],
  fetchOptions: {
    // Required: the server is on a different origin (api.oracord.com) from
    // the page (app.oracord.com), and even in local dev we need the cookie
    // to flow. Without this, every sign-in appears to "succeed" but no
    // subsequent request is authenticated.
    credentials: 'include',
  },
});

export type AuthClient = typeof authClient;
